import { render, staticRenderFns } from "./searchCompany.vue?vue&type=template&id=39a0520f&scoped=true"
import script from "./searchCompany.vue?vue&type=script&lang=js"
export * from "./searchCompany.vue?vue&type=script&lang=js"
import style0 from "./searchCompany.vue?vue&type=style&index=0&id=39a0520f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a0520f",
  null
  
)

export default component.exports